import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { getRutaInicialSesion } from '../utils/permisos'

export const RoleRedirect = () => {
  const { session } = useAuth()

  return <Navigate to={getRutaInicialSesion(session)} replace />
}
